import React, { useState, useContext } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuItem from "@material-ui/core/MenuItem";
import Box from "@material-ui/core/Box";
import Menu from "@material-ui/core/Menu";
import { makeStyles, withStyles,useTheme } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { WebContext, thumborImageUrl } from "../../../../../Utility";
import MobileNavDrawer from "./mobileNavbar";
import DefaultLogo from "../../../../../assets/images/defaultLogo.png";
import IconButton  from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import CloseIcon from "@material-ui/icons/Close";
import  Grid  from "@material-ui/core/Grid";
import LoginButton from "../../../Login/loginButton";
import  Link  from "@material-ui/core/Link";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
const useStyles = makeStyles((theme) => ({
  appbarmobile: {
    backgroundColor: theme?.agentTheme?.primary?.main,
    height: "50px",
    boxShadow: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 1rem",
    [theme.breakpoints.down(338)]: {
      gap: "1.5rem",
      height: "70px",
      margin: "auto",
      flexDirection: "column",
    },
  },

  appBar1: {
    backgroundColor: theme?.agentTheme?.primary?.main,
    height: "50px",
    boxShadow: "none",
  },
  socialMediaContainer: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
  },
  appBar: {
    boxShadow: "none",
    backgroundColor: "transparent !important",
    height: "80px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    gap: "6rem",
    alignItems: "center",
    [theme.breakpoints.down(1107)]: {
      gap: "1.5rem",
    },
  },
  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  flex: {
    width: "100%",
    maxWidth: "520px",
    margin: "0 auto",
  },
  menuLink: {
    textTransform: "none",
    fontWeight: 500,
    color: theme?.agentTheme?.card?.link_foreground,
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      color: theme?.agentTheme?.primary?.main,
    },
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
  },
  menuItem: {
    color: theme?.agentTheme?.card?.link_text_color,
    cursor: "pointer",
    fontSize: "15px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  paddingMobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",

    [theme.breakpoints.down(360)]: {
      paddingTop: "0.5rem",
    },
  },
}));

export const StyledMenu = withStyles((theme, info) => ({
  paper: {
    backgroundColor: theme?.agentTheme?.primary?.main,
    color: theme?.agentTheme?.primary?.foreground,
    borderRadius: "1px",
    minWidth: "180px",
  },
}))((props) => (
  <Menu
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
));

const LoginDropDownType = ({ items = {}, handleLogoutClick = () => {} }) => {
  const classes = useStyles();
  const { label = "", link = "", id = "" } = items;

  if (id === "logout") {
    return (
      <MenuItem
        onClick={
          typeof handleLogoutClick === "function"
            ? handleLogoutClick
            : undefined
        }
        className={classes.menuItem}
      >
        {(label || "").toUpperCase()}
      </MenuItem>
    );
  } else if (link) {
    return (
      <MenuItem component="a" href={link} className={classes.menuItem}>
        {(label || "").toUpperCase()}
      </MenuItem>
    );
  } else {
    return (
      <MenuItem className={classes.menuItem}>
        {(label || "").toUpperCase()}
      </MenuItem>
    );
  }
};

export default function Navbar({
  logo_url,
  isMobile = false,
  contentArr = [],
  username = "",
  memberProfile = {},
  widgetList = [],
  handleLogoutClick = () => {},
  loginItem = [],
}) {
  const theme = useTheme();
  const classes = useStyles();
  const { isLoggedIn = false } = useContext(WebContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [userAnchorEl, setUserAnchorEl] = useState(null);

  const handleUserMenuClick = (event) => setUserAnchorEl(event.currentTarget);
  const handleUserMenuClose = () => setUserAnchorEl(null);
  const [showMenuDrawer, setShowMenuDrawer] = useState(false);
  const seenTypes = new Set();
let { phone_numbers = [], emails = [] } = memberProfile;

  const [phoneNumber] = phone_numbers.filter(
    (item) => item.is_deleted === false && item.is_active === true
  );

  const [email] = emails.filter(
    (item) => item.is_deleted === false && item.is_active === true
  );
  const socialLinks = (memberProfile?.social_media_links || [])
    .filter((social) => social.is_active === true)
    .filter((social) => {
      if (seenTypes.has(social.type)) {
        return false;
      }
      seenTypes.add(social.type);
      return true;
    });

  const socialLogos = {
    Instagram: InstagramIcon,
    Facebook: FacebookIcon,
    Twitter: TwitterIcon,
    Youtube: YouTubeIcon,
    Linkedin: LinkedInIcon,
  };
  if (isMobile) {
    return (
      <Box>
        <Box className={classes.appbarmobile}>
          <Grid container alignItems="center" className={classes.flex}>
            <Grid
              item
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "flex-start",
                marginLeft: "2rem",
              }}
            >
              {socialLinks?.map((socialItem, index) => {
                const Logo = socialLogos[socialItem.type];

                return (
                  <Link
                    key={index}
                    href={socialItem.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                  >
                    <Box
                      style={{
                        color: theme?.agentTheme?.primary?.foreground,
                        cursor: "pointer",
                        height: "15px",
                        width: "15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "1rem",
                      }}
                    >
                      <Logo style={{ fontSize: "1rem" }} />
                    </Box>
                  </Link>
                );
              })}
            </Grid>
            <Grid item xs />
            <Grid item className={classes.paddingMobile}>
              <Box
                onMouseEnter={isLoggedIn ? handleUserMenuClick : undefined}
                onMouseLeave={isLoggedIn ? handleUserMenuClose : undefined}
              >
                <LoginButton
                  loginClass={classes.menuLink}
                  loginButton={true}
                  colornavbar15={true}
                />
              </Box>

              <StyledMenu
                anchorEl={userAnchorEl}
                keepMounted
                open={Boolean(userAnchorEl)}
                onClose={handleUserMenuClose}
              >
                {loginItem.map((sub, idx) => (
                  <LoginDropDownType
                    key={`user-sub-${idx}`}
                    items={sub}
                    handleLogoutClick={handleLogoutClick}
                  />
                ))}
              </StyledMenu>
            </Grid>
          </Grid>
        </Box>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar>
            <Grid
              container
              alignItems="center"
              style={{ maxWidth: "500px", margin: "0 auto", width: "100%" }}
            >
              <Grid
                item
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginTop: "1rem",
                }}
              >
                <a href={`/${username || ""}`}>
                  <img
                    src={
                      logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo
                    }
                    style={{
                      height: "50px",
                      width: "150px",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    alt="Logo"
                  />
                </a>
              </Grid>
              <Grid item xs />
              <Grid
                item
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={() => setShowMenuDrawer((prev) => !prev)}
                >
                  <Box
                    style={{
                      position: "relative",
                      width: "24px",
                      height: "24px",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <MenuIcon
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        fontSize: "30px",
                        transition: "opacity 0.3s ease",
                        opacity: showMenuDrawer ? 0 : 1,
                        transform: showMenuDrawer
                          ? "rotate(-90deg)"
                          : "rotate(0deg)",
                        color: theme?.agentTheme?.primary?.main,
                      }}
                    />
                    <CloseIcon
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        fontSize: "30px",
                        transition: "opacity 0.3s ease",
                        opacity: showMenuDrawer ? 1 : 0,
                        transform: showMenuDrawer
                          ? "rotate(0deg)"
                          : "rotate(90deg)",
                        color: theme?.agentTheme?.primary?.main,
                      }}
                    />
                  </Box>
                </IconButton>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>

        <MobileNavDrawer
          websiteData={{ memberProfile }}
          showDrawer={showMenuDrawer}
          setShowDrawer={setShowMenuDrawer}
          contentArr={contentArr}
          handleLogoutClick={handleLogoutClick}
          username={username}
          widgetList={widgetList}
          loginItem={loginItem}
        />
      </Box>
    );
  }

  return (
    <Box>
      <Box
        style={{
          width: "100%",
          height: "60px",
          display: "flex",
          alignItems: "center",
          backgroundColor: theme?.agentTheme?.primary?.main,
        }}
      >
       <Grid
  container
  style={{
    height: "100%",
    alignItems: "center",
    maxWidth: "1150px",
    padding:'0 2rem',
    display: "flex",
    justifyContent: "space-between", 
    flexDirection: "row",           
    margin: "0 auto",              
    width: "100%",                
  }}
>
  <Grid
    item
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
    }}
  >
    {socialLinks?.map((socialItem, index) => {
      const Logo = socialLogos[socialItem.type];
      return (
        <Link
          key={index}
          href={socialItem.link}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
        >
          <Box
            style={{
              color: theme?.agentTheme?.primary?.foreground,
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "30px",
              width: "30px",
              borderRadius: "50%",
            }}
          >
            <Logo style={{ fontSize: "1rem" }} />
          </Box>
        </Link>
      );
    })}
  </Grid>
  <Grid
    item
    style={{
    display: "flex",
    alignItems: "flex-end", 
    justifyContent: "flex-end", 
    flexDirection: "column",
    gap: "0.2rem",
    fontSize: "1rem",
    fontWeight: 600,
    color: theme?.agentTheme?.primary?.foreground,
    }}
  >
    {phoneNumber && (
      <span style={{ display: "flex", alignItems: "center"}}>
        <PhoneIcon style={{ fontSize: "1rem", marginRight: "0.3rem" }} />
        {`Phone: ${phoneNumber.phone_no}`}
      </span>
    )}
    {email && (
      <span style={{ display: "flex", alignItems: "center" ,}}>
        <EmailIcon style={{ fontSize: "1rem", marginRight: "0.3rem" }} />
        {`Mail: ${email.email}`}
      </span>
    )}
  </Grid>
</Grid>

      </Box>

      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Box>
            <a href={`/${username ? username : ""}`}>
              <img
                src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
                style={{
                  height: "50px",
                  width: "150px",
                  objectFit: "contain",
                  cursor: "pointer",
                  marginTop: "1rem",
                }}
                alt="Logo"
              />
            </a>
          </Box>
          <Box className={classes.navLinks}>
            {contentArr
              .filter((item) => item.isShow)
              .map((item, idx) => {
                if (item.dropdown && item.clickItem?.length > 0) {
                  return (
                    <Box
                      key={`dropdown-${idx}`}
                      display="flex"
                      alignItems="center"
                    >
                      <a
                        className={classes.menuLink}
                        onClick={(e) =>
                          setAnchorEl(anchorEl ? null : e.currentTarget)
                        }
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        {item.label.toUpperCase()}{" "}
                        <KeyboardArrowDownIcon
                          style={{ fontSize: "1.2rem", marginLeft: "0.5rem" }}
                        />
                      </a>

                      <StyledMenu
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        style={{ marginTop: "2rem" }}
                      >
                        {item.clickItem.map((sub, sidx) => (
                          <LoginDropDownType
                            key={`sub-${sidx}`}
                            items={
                              typeof sub.link === "object"
                                ? { ...sub, link: sub.link.pathname }
                                : sub
                            }
                            handleLogoutClick={handleLogoutClick}
                          />
                        ))}
                      </StyledMenu>
                    </Box>
                  );
                }
                return (
                  <a
                    key={`menu-${idx}`}
                    href={
                      typeof item.link === "string"
                        ? item.link
                        : item.link?.pathname
                    }
                    className={classes.menuLink}
                  >
                    {item.label.toUpperCase()}
                  </a>
                );
              })}
          </Box>
          <Box className={classes.rightSection}>
            <Box className={classes.rightSection}>
              <Box
                onClick={(e) =>
                  setUserAnchorEl(userAnchorEl ? null : e.currentTarget)
                }
                style={{ cursor: "pointer" }}
              >
                <LoginButton
                  loginClass={classes.menuLink}
                  tab={"paradise"}
                  primarycolor={true}
                />
              </Box>
              <StyledMenu
                anchorEl={userAnchorEl}
                keepMounted
                open={Boolean(userAnchorEl)}
                onClose={() => setUserAnchorEl(null)}
                style={{ marginTop: "1.5rem" }}
              >
                {loginItem.map((sub, idx) => (
                  <LoginDropDownType
                    key={`user-sub-${idx}`}
                    items={sub}
                    handleLogoutClick={handleLogoutClick}
                  />
                ))}
              </StyledMenu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
